export default function FeatureHighlights() {
  const features = [
    {
      icon: 'ri-speed-up-line',
      title: '不缓冲流畅播放',
      desc: '采用高速CDN加速技术，全国68个节点覆盖，告别卡顿等待，即点即播流畅观影。',
    },
    {
      icon: 'ri-4k-line',
      title: '超高清画质',
      desc: '支持720P至4K多种画质选择，专业转码处理，清晰画质带来影院级视觉享受。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '无广告纯净体验',
      desc: '从点击播放到进入正片，全程零广告干扰，只为给您最纯粹的观影体验。',
    },
    {
      icon: 'ri-database-2-line',
      title: '海量影视资源',
      desc: '10万+影视资源库，涵盖国内外大片、经典老片、热门剧集，满足各种观影需求。',
    },
  ];

  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
            为什么选择八戒电影网
          </h2>
          <p className="text-foreground-500 text-xs mt-2">四大核心优势，打造极致观影体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((feat, index) => (
            <div
              key={index}
              className="group p-5 md:p-6 rounded-lg bg-background-100 hover:bg-primary-500 transition-colors cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 group-hover:bg-background-50/20 group-hover:text-background-50 transition-colors mb-4">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 group-hover:text-background-50 text-sm mb-2 transition-colors">
                {feat.title}
              </h3>
              <p className="text-foreground-500 group-hover:text-background-50/80 text-xs leading-relaxed transition-colors">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}